import { environment } from 'src/enviroments';
import { SendNewMessage } from 'src/redux/chatMessages/types';
import { HttpHandler } from '../HttpHandler';
import { getAuthenticationToken } from 'src/shared/utils/getAuthenticationToken';

export const getChatMessagesList = async (roomId: string, limit: number, offset: number) => {
  const messagesData = await HttpHandler({
    method: 'GET',
    url: `${environment.AGORA_URL}/messages/${roomId}?limit=${limit}&offset=${offset}&orderBy=updated_at.desc`,
  });

  if (messagesData.data.length === 0) {
    return { ...messagesData, data: { roomId } };
  }

  return messagesData;
};

export const addNewMessage = async (data: SendNewMessage) => {
  const token = await getAuthenticationToken();

  const formData = new FormData();
  for (const key in data) {
    formData.append(
      key,
      // @ts-ignore
      key === 'fileInfo' ? JSON.stringify(data[key]) : data[key]
    );
  }

  const responseData = await fetch(`${environment.AGORA_URL}/message`, {
    body: formData,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  const response = await responseData.json();
  return response;
};

export const setViewedMessage = async (messageID: unknown) => {
  const response = await HttpHandler({
    method: 'PATCH',
    url: `${environment.AGORA_URL}/set-message-viewed/${messageID}`,
  });

  return response;
};
